module.exports = __webpack_public_path__ + "img/80.5468d5f9.jpg";